import { getDateString } from '../utils/dates'

// Provider-facing electronic-signature agreement, required once per provider (super-admin)
// before they may sign practice contracts. Distinct from the patient electronic consent.
// NOTE: draft copy — review/adjust wording with legal/product before shipping.

export const practiceContractConsentHeader = 'Electronic Signature Agreement'

export const practiceContractConsentPreface =
  'Before signing practice contracts and agreements with Hamilton Billing electronically, the following must be agreed to and acknowledged by you as an authorized super-admin representative of your practice:'

export const getPracticeContractConsentFormHeader = (signedOn: string) =>
  `You signed this agreement on ${getDateString(signedOn)}. If you have any questions or concerns, please contact us via our website at https://hamiltonbilling.com or send an email to info@hamiltonbilling.com.`

export const practiceContractConsentCheckbox1 =
  'I agree to both access and sign practice contracts and/or agreements with Hamilton Billing electronically.'

export const practiceContractConsentCheckbox2 =
  'I confirm that I am a super administrator of my practice and am authorized to sign practice contracts and agreements on the practice’s behalf.'

export const practiceContractConsentCheckbox3 =
  'In order to obtain a copy of a signed practice contract for the practice’s records, I agree to download it in lieu of receiving a paper copy from Hamilton Billing. I understand I can access these files by logging into the Hamilton Billing providers portal at any time.'

export const practiceContractConsentCheckbox4 =
  'If at any point the practice wishes to withdraw consent to sign documents electronically, I will email info@hamiltonbilling.com informing Hamilton Billing as such. I understand that a paper copy of any signed practice contract can be requested by emailing info@hamiltonbilling.com, and that Hamilton Billing must be given up to 30 calendar days to respond and send the copy.'

export const practiceContractConsentCheckboxes = [
  practiceContractConsentCheckbox1,
  practiceContractConsentCheckbox2,
  practiceContractConsentCheckbox3,
  practiceContractConsentCheckbox4,
]
